// Mirror of backend `models/src/bi/export.ts` (the wire types and names)
// and of the generated enums `BiExportStatus` and `BiExportPageSize`.

import { BiDashboardFilters } from './dashboard';
import { BiDateWindow } from './query';
import { BiPalette } from './viz';

export enum BiExportStatus {
  Queued = 1,
  Running = 2,
  Succeeded = 3,
  Failed = 4,
}

export enum BiExportPageSize {
  A4 = 'a4',
  A5 = 'a5',
  WebSmall = 'web_small',
  WebMedium = 'web_medium',
  WebLarge = 'web_large',
}

/** Why an export failed. */
export enum BiExportFailure {
  DashboardUnavailable = 'dashboard_unavailable',
  Timeout = 'timeout',
  Failed = 'failed',
}

export const kBiExportFailureTexts: Record<BiExportFailure, string> = {
  [BiExportFailure.DashboardUnavailable]: '看板已删除，或你已不能查看它。',
  [BiExportFailure.Timeout]: '导出用时过长，没有完成，请稍后重新导出。',
  [BiExportFailure.Failed]: '导出没有完成，请稍后重新导出。',
};

export const kBiExportPageSizeNames: Record<BiExportPageSize, string> = {
  [BiExportPageSize.A4]: '纸张 · A4',
  [BiExportPageSize.A5]: '纸张 · A5',
  [BiExportPageSize.WebSmall]: '网页 · 小（390px）',
  [BiExportPageSize.WebMedium]: '网页 · 中（768px）',
  [BiExportPageSize.WebLarge]: '网页 · 大（1280px）',
};

/** `POST /bi/dashboards/:dashboardId/exports`. */
export interface BiRequestDashboardExport {
  filters: BiDashboardFilters;
  pageSize: BiExportPageSize;
  /** The dashboard's own draws it as on screen; another, every card. */
  palette: BiPalette;
}

/** One export as its requester's history shows it. */
export interface BiDashboardExportView {
  id: string;
  dashboardId: string;
  dashboardName: string;
  window: BiDateWindow | null;
  pageSize: BiExportPageSize;
  palette: BiPalette;
  status: BiExportStatus;
  failure: BiExportFailure | null;
  queuedAt: string;
  startedAt: string | null;
  finishedAt: string | null;
  pageCount: number | null;
  cardCount: number | null;
  failedCardCount: number | null;
  fileSize: number | null;
  /** A signed link, good for an hour; null unless it can be downloaded. */
  downloadUrl: string | null;
}

/** `GET /bi/exports`: the requester's exports, newest first. */
export interface BiListDashboardExportsRequest {
  beforeId?: string;
  limit?: number;
}

export interface BiDashboardExportList {
  items: BiDashboardExportView[];
  hasMore: boolean;
}
